import { api } from './api';
import { fetchResource } from './fetchResource';

export function fetchWealthManagement() {
  return dispatch => fetchResource(dispatch, 'modules/wealth_management', 'WEALTH_MANAGEMENT_MODULE_FETCHED');
}

export function fetchSpendingPlan() {
  return dispatch => fetchResource(dispatch, 'modules/spending_plan', 'SPENDING_PLAN_MODULE_FETCHED');
}

export function fetchGuaranteedIncome() {
  return dispatch => fetchResource(dispatch, 'modules/guaranteed_income', 'GUARANTEED_INCOME_MODULE_FETCHED');
}

export function updateGuaranteedIncomeData(data) {
  return dispatch => {
    return api.put('/api/modules/guaranteed_income', data).then(response => {
      dispatch({ type: 'GUARANTEED_INCOME_MODULE_FETCHED', payload: response.data });
    });
  };
}

export function fetchSpendingSourcesGuaranteedIncome(diaConversion, financialShock, planToAge) {
  return dispatch => {
    return api
      .get(
        `/api/modules/guaranteed_income/spending_sources?dia_conversion=${diaConversion}&financial_shock=${financialShock}${
          planToAge ? `&plan_to_age=${planToAge}` : `&asdf=${planToAge}`
        }`
      )
      .then(response => {
        dispatch({
          type: 'GUARANTEED_INCOME_SPENDING_SOURCES_FETCHED',
          payload: { data: response.data },
        });
      });
  };
}

export function changeWealthManagementStage(stage) {
  return dispatch => {
    return api.put('/api/modules/wealth_management', { stage }).then(response => {
      dispatch({ type: 'WEALTH_MANAGEMENT_MODULE_FETCHED', payload: response.data });
    });
  };
}

export function updateWealthManagementData(data) {
  return dispatch => {
    return api.put('/api/modules/wealth_management', data).then(response => {
      dispatch({ type: 'WEALTH_MANAGEMENT_MODULE_FETCHED', payload: response.data });
    });
  };
}

export function fetchAllocationsByAge(riskLevel) {
  return dispatch => {
    return api.get(`/api/modules/investment_mix/allocations?risk_level=${riskLevel}`).then(response => {
      dispatch({ type: 'INVESTMENT_MIX_ALLOCATIONS_FETCHED', payload: { riskLevel: riskLevel, data: response.data } });
    });
  };
}

export function updateSpendingPlanData(data) {
  return dispatch => {
    return api.put('/api/modules/spending_plan', data).then(response => {
      dispatch({ type: 'SPENDING_PLAN_MODULE_FETCHED', payload: response.data });
    });
  };
}

export function fetchSpendingSources(withdrawalRate) {
  return dispatch => {
    return api.get(`/api/modules/spending_plan/spending_sources?withdrawal_rate=${withdrawalRate}`).then(response => {
      dispatch({
        type: 'SPENDING_PLAN_SPENDING_SOURCES_FETCHED',
        payload: { withdrawalRate: withdrawalRate, data: response.data },
      });
    });
  };
}

export function fetchWithdrawalSources() {
  return dispatch => {
    return api.get(`/api/modules/tax_strategy/withdrawal_sources`).then(response => {
      dispatch({
        type: 'TAX_STRATEGY_WITHDRAWAL_SOURCES_FETCHED',
        payload: { data: response.data },
      });
    });
  };
}
